let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4ado7")).then(() => parcelRequire('7Tg35'));